import { Badge } from "@/components/ui/badge";
import { Link } from "react-router-dom";

export default function BlogSidebar() {
  return (
    <aside className="hidden lg:block">
      <div className="sticky top-24 h-fit space-y-8">
        <div className="bg-muted/30 p-6 rounded-xl border border-border">
          <h3 className="font-bold text-lg mb-6 text-primary">Related Articles</h3>
          <div className="space-y-6">
            <Link to="/blog/spinal-decompression" className="group block">
              <div className="flex gap-4">
                <img 
                  src="https://wsrv.nl/?url=https://vibe.filesafe.space/1774569058151009111/assets/58600117-1663-43e4-98fd-7b421e93ecd3.png&w=150&output=webp&q=80" 
                  alt="Spinal Decompression" 
                  className="w-20 h-20 rounded-md object-cover transition-transform group-hover:scale-105"
                  loading="lazy"
                />
                <div>
                  <Badge variant="secondary" className="mb-2 text-[10px] bg-secondary text-secondary-foreground">Therapies</Badge>
                  <h4 className="font-medium text-sm group-hover:text-accent transition-colors line-clamp-2">
                    Understanding Non-Surgical Spinal Decompression
                  </h4>
                </div>
              </div>
            </Link>
            <Link to="/blog/red-light-therapy" className="group block">
              <div className="flex gap-4">
                <img 
                  src="https://wsrv.nl/?url=https://vibe.filesafe.space/1774569058151009111/attachments/e3fefda6-4541-41e2-b1b1-3631721c72b4.png&w=150&output=webp&q=80" 
                  alt="Red Light Therapy" 
                  className="w-20 h-20 rounded-md object-cover transition-transform group-hover:scale-105"
                  loading="lazy"
                />
                <div>
                  <Badge variant="secondary" className="mb-2 text-[10px] bg-secondary text-secondary-foreground">Wellness</Badge>
                  <h4 className="font-medium text-sm group-hover:text-accent transition-colors line-clamp-2">
                    The Science Behind Red Light Therapy
                  </h4>
                </div>
              </div>
            </Link>
            <Link to="/blog/inflammation-joint-pain" className="group block">
              <div className="flex gap-4">
                <img 
                  src="https://wsrv.nl/?url=https://vibe.filesafe.space/1774569058151009111/assets/5e4dd28e-c675-4742-929c-741691a914c4.png&w=150&output=webp&q=80" 
                  alt="Inflammation" 
                  className="w-20 h-20 rounded-md object-cover transition-transform group-hover:scale-105"
                  loading="lazy"
                />
                <div>
                  <Badge variant="secondary" className="mb-2 text-[10px] bg-secondary text-secondary-foreground">Health Tips</Badge>
                  <h4 className="font-medium text-sm group-hover:text-accent transition-colors line-clamp-2">
                    How Inflammation Affects Joint Pain
                  </h4>
                </div>
              </div>
            </Link>
            <Link to="/blog/neuropathy-softwave" className="group block">
              <div className="flex gap-4">
                <img 
                  src="https://wsrv.nl/?url=https://softwavetrt.com/wp-content/uploads/2026/02/softwave099-1.png&w=150&output=webp&q=80" 
                  alt="Neuropathy" 
                  className="w-20 h-20 rounded-md object-cover transition-transform group-hover:scale-105"
                  loading="lazy"
                />
                <div>
                  <Badge variant="secondary" className="mb-2 text-[10px] bg-secondary text-secondary-foreground">Neuropathy</Badge>
                  <h4 className="font-medium text-sm group-hover:text-accent transition-colors line-clamp-2">
                    Finding Relief from Neuropathy with SoftWave TRT
                  </h4>
                </div>
              </div>
            </Link>
          </div>
        </div>
      </div>
    </aside>
  );
}
